import { Component, OnInit } from '@angular/core';
import {
  faBagShopping,
  faCoins,
  faGauge,
  faHeart,
  faMessage,
  faMoneyCheckDollar,
  faRightFromBracket,
  faSpinner,
  faSquarePlus,
  faUser,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';
import { User } from './interfaces/user.interface';
import { UserService } from './services/user.service';

@Component({
  selector: 'fc-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
export class UserComponent implements OnInit {
  faSquarePlus = faSquarePlus;
  faUser = faUser;
  faMoneyCheckDollar = faMoneyCheckDollar;
  faGauge = faGauge;
  faCoins = faCoins;
  faBagShopping = faBagShopping;
  faMessage = faMessage;
  faHeart = faHeart;
  faWandMagicSparkles = faWandMagicSparkles;
  faRightFromBracket = faRightFromBracket;
  faSpinner = faSpinner;
  user: User = {} as User;

  verifyLoading = false;
  constructor(private userService: UserService) {
    this.userService.getUserData().subscribe((data) => {
      this.user = data;
    });
  }

  ngOnInit(): void {}
  verifyEmail() {
    this.verifyLoading = true;
    this.userService.resendVerifyEmail().subscribe(
      (data) => (this.verifyLoading = false),
      (error) => (this.verifyLoading = false)
    );
  }
}
